export default __webpack_public_path__ + "static/media/25120403.1bb3cfc8.jpg";